import { Position } from '@nucleus/types/web';
import { Alignment } from '@nucleus/types/web/alignment';
import React from 'react';
import styled, { css } from 'styled-components';
import { BlockLayout, blockLayoutInnerProps } from '../../blockLayouts/Base';
import { BlockCover } from '../../blocks/BlockCover';
import { blockInfoHasContent } from '../../blocks/BlockInfo';
import { BlockPost } from '../../blocks/BlockPost';
import { SpacerTop } from '../../sectionLayouts/Spacers';
import { BlockLayoutProps } from '../../types/component';
import { PostBlockLayoutProps, getPositionRow } from './PostLayout';

export const PostBlockLayoutCover = (props: PostBlockLayoutProps): JSX.Element => {
  const innerProps = blockLayoutInnerProps(props);

  const row = getPositionRow(props.blockInfoPosition);

  const renderInfo = blockInfoHasContent(props.blocks[0]);

  return (
    <StyledBlockLayout
      {...props}
      bodyAlignment={props.blocks[0]?.bodyAlignment ?? props.blockBodyAlignment}
      row={row}
      renderInfo={renderInfo}
    >
      <SpacerTop />
      <StyledBlockCover {...innerProps} block={props.blocks[0]} />
      <StyledSpacerBottom />
      <StyledBlockPost {...innerProps} block={props.blocks[0]} />
    </StyledBlockLayout>
  );
};

const PostHeightMap = {
  small: 1,
  medium: 2,
  large: 3,
};

const getPostPadding = (props: BlockLayoutProps) => {
  const defaultHeight = 'small';
  const multiplier = PostHeightMap[props.height ?? defaultHeight];

  return css`
    padding: calc(var(--unit-length) * ${multiplier}) var(--unit-length);
  `;
};

const StyledBlockCover = styled(BlockCover)``;
const StyledBlockPost = styled(BlockPost)``;

const StyledSpacerBottom = styled(SpacerTop)``;

const StyledBlockLayout = styled(BlockLayout)<{
  bodyAlignment?: Alignment;
  row: Position;
  renderInfo: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  ${StyledBlockCover} {
    position: relative;
    z-index: 1;
  }

  ${StyledBlockPost} {
    ${getPostPadding}
    padding-top: ${(props) => (props.renderInfo ? '0' : undefined)};

    justify-content: ${(props) => {
      switch (props.row) {
        case Position.Top:
          return 'flex-start';
        case Position.Center:
          return 'center';
        case Position.Bottom:
          return 'flex-end';
        default:
          return;
      }
    }};

    ${(props) => {
      switch (props.bodyAlignment) {
        case Alignment.Left:
          return css`
            text-align: left;
          `;
        case Alignment.Right:
          return css`
            text-align: right;
          `;
        case Alignment.Center:
        default:
          return css`
            text-align: center;
          `;
      }
    }}
  }
`;
